import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class EquisOverlayComponent {
    constructor() {
        this.opacity = 0.7;
        this.opacityScale = 0.1;
    }
    increaseOpacity(opacity) {
        this.opacity += opacity ? opacity : this.opacityScale;
    }
    decreaseOpacity(opacity) {
        this.opacity -= opacity ? opacity : this.opacityScale;
    }
}
EquisOverlayComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisOverlayComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EquisOverlayComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisOverlayComponent, selector: "z-overlay, equis-overlay", inputs: { opacity: "opacity" }, ngImport: i0, template: "<div class=\"overlay\" [ngStyle]=\"{ opacity: opacity }\"></div>\n", styles: [".overlay{background-color:#000;height:100%;left:0;position:fixed;top:0;width:100%;z-index:800}\n"], dependencies: [{ kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisOverlayComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-overlay, equis-overlay', template: "<div class=\"overlay\" [ngStyle]=\"{ opacity: opacity }\"></div>\n", styles: [".overlay{background-color:#000;height:100%;left:0;position:fixed;top:0;width:100%;z-index:800}\n"] }]
        }], propDecorators: { opacity: [{
                type: Input
            }] } });

class EquisOverlayModule {
    static forRoot() {
        return {
            ngModule: EquisOverlayModule,
        };
    }
}
EquisOverlayModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisOverlayModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisOverlayModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisOverlayModule, declarations: [EquisOverlayComponent], imports: [CommonModule], exports: [EquisOverlayComponent] });
EquisOverlayModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisOverlayModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisOverlayModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EquisOverlayComponent],
                    imports: [CommonModule],
                    exports: [EquisOverlayComponent],
                }]
        }] });

/*
 * Public API Surface of equis-overlay
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EquisOverlayComponent, EquisOverlayModule };
